module.exports = __webpack_public_path__ + "assets/img/re12.22fd7356.png";